/* eslint-disable max-len */
import {API_URL} from 'utils/constants/app';
import {RequestHelper} from 'utils/helpers/RequestHelper';

const fileServiceUrl = `${API_URL}/files`;

export const FILE_ACCESS_LEVEL = {
  PUBLIC: "PUBLIC",
  PRIVATE: "PRIVATE"
}

const downloadPublicFile = (recid) => RequestHelper.GET(`${fileServiceUrl}/download/${recid}`);
const downloadPrivateFile = (recid) => RequestHelper.GET(`${fileServiceUrl}/private/download/${recid}`);
const downloadFile = (recid, accessLevel) => {
  if (accessLevel === FILE_ACCESS_LEVEL.PUBLIC) {
    return downloadPublicFile(recid);
  } else {
    return downloadPrivateFile(recid);
  }
}

export const FileService = {
  downloadFile
};